export const IS_PROD = process.env.NODE_ENV === 'production';

export default IS_PROD ? 'production' : 'development';
